import get from 'lodash/get';

export default player => {
  if (player.teams) {
    return get(player, 'teams[0]', {});
  } else if (player.team) {
    return get(player, 'team', {});
  }
  return {};
};
